import {Component, OnInit, OnDestroy, ViewChild, Input} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../services/auth.service";
import {MatLegacyTableDataSource as MatTableDataSource} from "@angular/material/legacy-table";
import {MatLegacyPaginator as MatPaginator} from "@angular/material/legacy-paginator";
import {NeFilter} from "./ne.filter";
import { debounceTime } from 'rxjs/operators';
import {LookupService} from "../srvs/lookup";
import {SettingsPersistenceService} from "../services/settings-persistence.service";

@Component({
  selector: 'micro-nes',
  templateUrl: './nes.component.html'
})
export class NesComponent implements OnInit, OnDestroy  {

  @Input()
  siteId:any;

  dataSource:MatTableDataSource<any> = new MatTableDataSource<any>();
  displayedColumns:string[] = ['name','host','minPing','maxPing','avgPing'];
  filter:NeFilter = new NeFilter(this.auth);
  pageSettings: SettingsPersistenceService;
  selectedCluster: any;
  clusterNames = new Map<string, string>();

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  get embedded() {
    return !!this.siteId;
  }

  constructor(protected auth:AuthService,
              private env:EnvService,
              private http:HttpClient,
              public lookupService:LookupService) {
    this.filter.anyChange.pipe(debounceTime(500)).subscribe(change => {
      this.reload();
    });
  }

  ngOnInit() {
    this.pageSettings = new SettingsPersistenceService(sessionStorage, "micro-nes");
    this.pageSettings
      .setFilter(this.filter)                       // page filter object
      .setPaginator(this.paginator)                 // page paginator object
      .setEmbedded(this.embedded)                   // if true, the service will not save settings to storage
      .setEmbeddedFilterProps({siteId: this.siteId}) // if embedded is true, the service will use this object to initialize filter
      .init();

    if (this.siteId) {
      this.filter.siteId = this.siteId;
    }

    if (this.filter.clusterId) {
      this.http.get(`${this.env.e.url}/domain/cmdbClusters/${this.filter.clusterId}`)
        .subscribe(cluster => this.selectedCluster = cluster);
    }
    this.reload();
  }

  ngOnDestroy() {
  }

  reload() {
    let params:HttpParams = this.filter.getParams()
        .set("page", '' + (this.paginator.pageIndex || 0))
        .set("size", '' + (this.paginator.pageSize || this.pageSettings.defaultPageSize))
      ;
    if (!this.auth.isCompanyAdmin()) {
      params = params.set("companyId", this.filter.companyId);
    }

    this.http.get(`${this.env.e.url}/domain/nes`, {params: params}).subscribe(
      data => {
        let page = data as any;
        this.dataSource.data = page.content;
        this.paginator.pageIndex = page.number;
        this.paginator.pageSize = page.size;
        this.paginator.length = page.totalElements;
        for (const ne of page.content) {
          if (ne.clusterId && !this.clusterNames.has(ne.clusterId)) {
            this.clusterNames.set(ne.clusterId, ne.clusterId);
            this.http.get(`${this.env.e.url}/domain/cmdbClusters/${ne.clusterId}`)
              .subscribe((cluster: any) => {
                this.clusterNames.set(ne.clusterId, cluster?.name || ne.clusterId);
              });
          }
        }
      }
    );
  }
}
